import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import Close from "@material-ui/icons/Close";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import ScanComponent from "./ScanComponent";
import Barcode from "./assets/mdi_barcode_scan_black.svg";

const styles = {
  scanPopup: {
    width: "400px",
    minHeight: "230px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "14px",
    boxSizing: "border-box",
    "@media(max-width: 470px)": {
      width: "350px",
      padding: "16px 0",
    },
  },
  scanPopupNav: {
    width: "100%",
    height: "24px",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    placeItems: "center",
    marginBottom: "40px",
  },
  interactPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    "@media(max-width: 470px)": {
      width: "100%",
      padding: "0 4px",
    },
  },
  scanTitle: {
    display: "flex",
    alignItems: "center",
    "& div": {
      marginLeft: "8px",
    },
  },
  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",
    marginRight: "15px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    },
  },
  errorMsg: {
    color: "#eb3c39",
    fontSize: "14px",
  },
  buttonContainer: {
    marginTop: "40px",
    display: "flex",
    justifyContent: "space-between",
  },
  cancelBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "white",
    borderRadius: "2px",
    border: "none",
    color: "#5f00a0",
    fontWeight: "500",
  },
};

const QrPopup = (props) => {
  const { classes } = props;

  return (
    <div className={classes.scanPopup}>
      <div className={classes.scanPopupNav}>
        <div className={classes.scanTitle}>
          <img src={Barcode} alt="Scan Product" />
          <div>{I18n.get("qr_code_scan").toUpperCase()}</div>
        </div>
        <div className={classes.closeButton}>
          <Close
            onClick={() => {
              props.setOpenScan(false);
              props.setScanError("");
            }}
          />
        </div>
      </div>
      <div className={classes.interactPanel}>
        <ScanComponent
          setOpenScan={props.setOpenScan}
          setScanError={props.setScanError}
          handleScanDialog={props.handleScanDialog}
        />
        <div id="debug_output"></div>
        {props.errorMsg ? (
          <div className={classes.errorMsg}>{props.errorMsg}</div>
        ) : null}
      </div>
      <div className={classes.buttonContainer}>
        <button
          className={classes.cancelBtn}
          type="button"
          onClick={() => {
            props.setOpenScan(false);
            props.setScanError("");
          }}
        >
          {I18n.get("site_cancel").toUpperCase()}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(QrPopup))
);
